import {
  fetchUserFromSession,
  type SessionIdentity,
} from '@/apis/fetchUser';
import headerObject from '@/types/headerObj';
import emptyHeaderObj from '@/types/emptyHeaderObj';
import useUserStore from '@/state/userState';

const headerObj: headerObject = emptyHeaderObj;

export const fetchUserWithRetry = async (
  sessionUser: SessionIdentity | string | null | undefined,
  maxAttempts: number
) => {
  // Back-compat: older callers passed email string only.
  const identity: SessionIdentity | undefined =
    typeof sessionUser === 'string'
      ? { email: sessionUser }
      : (sessionUser ?? undefined);

  let attempts = 0;
  let user = null;
  while (attempts < maxAttempts) {
    try {
      const userStore = useUserStore.getState().user;
      if (userStore?.accessToken) {
        headerObj.Authorization = `Bearer ${userStore.accessToken}`;
      }
      if (identity?.email) {
        headerObj.Useremail = identity.email;
      }
      user = await fetchUserFromSession(identity, headerObj);
    } catch (error) {
      console.error(`Attempt ${attempts + 1} failed with error: ${error}`);
    }
    if (user) {
      break;
    }
    attempts++;
    await new Promise((resolve) => setTimeout(resolve, 1000));
  }
  return user;
};

export const treatUserNames = (
  firstName: string,
  lastName: string,
  username: string
) => {
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }
  if (username) {
    return username;
  }
  return '';
};
